import React from "react";
import { Link } from "react-router-dom";
import { Globe, MessageCircle, Hash, Users, MapPin, Phone, Mail, Download, Smartphone } from "lucide-react";
import { useBranding } from "../context/BrandingContext";
import toast from 'react-hot-toast';

export default function PublicFooter() {
  const { branding } = useBranding();

  return (
    <footer className="bg-slate-950 pt-20 pb-10 text-slate-300 font-['Inter',sans-serif]">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        <div className="space-y-6">
          <h2 className="text-2xl font-black text-white tracking-tighter">{(branding?.instituteName || "ANTIGRAVITY").toUpperCase()}</h2>
          <p className="text-sm leading-relaxed text-slate-400">
            Empowering students with smart digital education. Live classes, AI tools, and expert guidance.
          </p>
          <div className="flex gap-4">
            <a href="#" className="w-10 h-10 bg-slate-900 rounded-full flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-colors"><Globe size={18}/></a>
            <a href="#" className="w-10 h-10 bg-slate-900 rounded-full flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-colors"><MessageCircle size={18}/></a>
            <a href="#" className="w-10 h-10 bg-slate-900 rounded-full flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-colors"><Hash size={18}/></a>
            <a href="#" className="w-10 h-10 bg-slate-900 rounded-full flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-colors"><Users size={18}/></a>
          </div>
        </div>
        
        <div>
          <h4 className="text-white font-black uppercase tracking-widest text-sm mb-6">Explore</h4>
          <ul className="space-y-3 text-sm font-medium">
            <li><Link to="/about" className="hover:text-indigo-400 transition-colors">About Us</Link></li>
            <li><Link to="/public-courses" className="hover:text-indigo-400 transition-colors">All Courses</Link></li>
            <li><Link to="/public-live-classes" className="hover:text-indigo-400 transition-colors">Live Classes</Link></li>
            <li><Link to="/success-stories" className="hover:text-indigo-400 transition-colors">Success Stories</Link></li>
            <li><Link to="/contact" className="hover:text-indigo-400 transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-black uppercase tracking-widest text-sm mb-6">Contact</h4>
          <ul className="space-y-4 text-sm font-medium">
            <li className="flex items-start gap-3">
              <MapPin size={18} className="text-indigo-500 shrink-0 mt-0.5" />
              <span>{branding?.contactAddress || "123 Education Hub, Knowledge Park, Tech City, 110001"}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={18} className="text-indigo-500 shrink-0" />
              <span>{branding?.contactPhone || "+91 98765 43210"}</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={18} className="text-indigo-500 shrink-0" />
              <span>{branding?.contactEmail || "support@institute.com"}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-black uppercase tracking-widest text-sm mb-6">Download App</h4>
          <p className="text-sm text-slate-400 mb-4">Get our app for the best mobile learning experience.</p>
          <div className="space-y-3">
            <button onClick={() => toast('iOS App coming soon!', { icon: '🍎' })} className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-slate-900 rounded-xl hover:bg-slate-800 transition-colors border border-slate-800 text-white">
              <Download size={20} /> <span className="font-bold text-sm">App Store</span>
            </button>
            <button onClick={() => toast('Android App coming soon!', { icon: '🤖' })} className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-slate-900 rounded-xl hover:bg-slate-800 transition-colors border border-slate-800 text-white">
              <Smartphone size={20} /> <span className="font-bold text-sm">Google Play</span>
            </button>
          </div>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 pt-8 border-t border-slate-800 text-center text-sm font-medium text-slate-500 flex flex-col md:flex-row justify-between items-center gap-4">
        <p>{branding?.footerText || "© 2026 Smart Education. All rights reserved."}</p>
        <div className="flex gap-4">
          <Link to="/" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/" className="hover:text-white transition-colors">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}
